import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ISkillsState } from './types'
import LoadableModel from '@/models-ts/LoadableModel'
import { RootState } from '@/store'

const getInitialState = (): ISkillsState => ({
  skills: new LoadableModel({ value: [] }),
  deprecatedSkills: [],
  skillDetails: null,
})

export default (): Module<ISkillsState, RootState> => ({
  namespaced: true,
  state: getInitialState(),
  mutations,
  getters,
  actions,
})
